import React from 'react';
import { Formik } from 'formik';
import { Grid, IconButton, makeStyles } from '@material-ui/core';
import { Close as CloseIcon, Today as TodayIcon } from '@material-ui/icons';
import DatePicker from 'components/DatePicker';
import i18n from 'i18n';
import Button from 'components/Button';
import { DateFilterFields } from 'modules/environments/interfaces';
import { isValid, format } from 'date-fns';
import styles from './styles';

interface DateFilterProps {
  onOpenFilter?: (open: boolean) => void;
  onSubmit: (values: DateFilterFields) => void;
}

const initialValues: DateFilterFields = {
  'start-date': '',
  'end-date': '',
};

const DateFilter = ({ onOpenFilter, onSubmit }: DateFilterProps) => {
  const classes = makeStyles(styles)();
  const [openDateFilter, setOpenDateFilter] = React.useState(false);

  React.useEffect(() => {
    if (onOpenFilter) {
      onOpenFilter(openDateFilter);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openDateFilter]);

  return (
    <Grid className={classes.filterSelector}>
      {openDateFilter ? (
        <Formik initialValues={initialValues} onSubmit={onSubmit}>
          {({ values, setFieldValue, submitForm }) => (
            <Grid container spacing={2} justify="flex-start">
              <IconButton
                onClick={() => {
                  setOpenDateFilter(false);
                  setFieldValue('start-date', null);
                  setFieldValue('end-date', null);
                  onSubmit({ 'start-date': '', 'end-date': '' });
                }}
              >
                <CloseIcon className={classes.closeIcon} />
              </IconButton>

              <DatePicker
                id="start_date"
                type="datetimeFilter"
                label={i18n.t('INITIAL_DATE_KEY')}
                keyValue="start-date"
                value={values?.['start-date']}
                setFieldsValue={(key, value) => {
                  if (isValid(value)) {
                    const newValue = format(
                      value as Date,
                      "yyyy-MM-dd'T'HH:mm:ss'-0300'"
                    );
                    setFieldValue(key, newValue);
                  }
                }}
                shrink={
                  values?.['start-date'] !== '' &&
                  values?.['start-date'] !== null &&
                  values?.['start-date'] !== undefined
                }
              />
              <DatePicker
                id="end_date"
                type="datetimeFilter"
                label={i18n.t('FINAL_DATE_KEY')}
                keyValue="end-date"
                value={values?.['end-date']}
                minDate={values?.['start-date']}
                setFieldsValue={(key, value) => {
                  if (isValid(value)) {
                    const newValue = format(
                      value as Date,
                      "yyyy-MM-dd'T'HH:mm:ss'-0300'"
                    );
                    setFieldValue(key, newValue);
                  }
                }}
                shrink={
                  values?.['end-date'] !== '' &&
                  values?.['end-date'] !== null &&
                  values?.['end-date'] !== undefined
                }
              />
              <Grid item>
                <Button
                  id="submit-button"
                  onClick={submitForm}
                  submitButton
                  disabled={
                    !values?.['start-date'] ||
                    !values?.['end-date'] ||
                    values?.['start-date'] > values?.['end-date']
                  }
                >
                  {i18n.t('APPLY_KEY')}
                </Button>
                {(values?.['start-date'] || values?.['end-date']) && (
                  <Button
                    id="clear-button"
                    onClick={() => {
                      setFieldValue('start-date', null);
                      setFieldValue('end-date', null);
                    }}
                    deleteButton
                  >
                    {i18n.t('CLEAR_FORM_KEY')}
                  </Button>
                )}
              </Grid>
            </Grid>
          )}
        </Formik>
      ) : (
        <Button
          startIcon={<TodayIcon />}
          variant="outlined"
          onClick={() => setOpenDateFilter(true)}
          className={classes.applyButton}
        >
          {i18n.t('APPLY_DATE_FILTERS_KEY')}
        </Button>
      )}
    </Grid>
  );
};

export default DateFilter;
